// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"155":"books","594":"about"}[chunkId] + "." + {"155":"3d34d4a6","594":"57a6a19e"}[chunkId] + ".js";
};